import type { MonospacePolicy, MonospaceRolePolicy, RawMonospacePolicy } from '#layers/data-model/public';
import { RStoreSchema } from '#imports';

export const RolePolicy = RStoreSchema.withItemType<MonospaceRolePolicy>().defineCollection({
	name: 'MonospaceRolePolicy',
	scopeId: 'monospace-default',
	getKey: (item) => `${item.roleId}__${item.policyId}`,
	meta: {
		defaultFields: ['roleId', 'policyId'],
		useWorkspaceSlug: true,
	},
});

export const Policy = RStoreSchema.withItemType<MonospacePolicy>().defineCollection({
	name: 'MonospacePolicy',
	scopeId: 'monospace-default',
	fields: {
		content: {},
	},
	meta: {
		defaultFields: ['id', 'name', 'content', 'isProtected'],
		endpoint: 'policies',
		fetchOnCreate: true,
		fetchOnUpdate: true,
		useWorkspaceSlug: true,
	},
});

// This is a model for the _actual_ policy that is stored in the DB, with global ids instead of collection names
export const RawPolicy = RStoreSchema.withItemType<RawMonospacePolicy>().defineCollection({
	name: 'RawMonospacePolicy',
	scopeId: 'monospace-default',
	fields: {
		// TODO(hannes) this is temporary until we switch API to JSON output
		content: {
			parse: (value) => typeof value === 'string' ? JSON.parse(value) : value,
		},
	},
	meta: {
		defaultFields: ['id', 'name', 'content'],
		endpoint: '/items/MonospacePolicy',
		useWorkspaceSlug: true,
	},
});
